import { REGISTRY_ROLES } from 'registry/constants'
import {
  settingsAccountInfoPath,
  settingsBirthdayPreferencesPath,
  settingsCashFundPreferencesPath,
  settingsConsolidatedShippingPath,
  settingsEmailPreferencesPath,
  settingsGiftCardsAndPromotionsPath,
  settingsPath,
  settingsRegistryCollaboratorsPath,
  settingsRegistryPath,
  settingsRegistryVisibilityPath,
  settingsShippingAddressPath,
  settingsYourOrdersPath,
} from 'lib/urls'
import AccountInfo from './account-info'
import EmailPreferences from './email-preferences'
import GiftCardsAndPromotions from './gift-cards-and-promotions'
import RegistryCollaborators from './registry-collaborators'
import RegistryVisibility from './registry-visibility'
import CashFundPreferences from './cash-fund-preferences'
import ShippingAddress from './shipping-address'
import ConsolidatedShipping from './consolidated-shipping'
import YourOrders from './your-orders'
import { BirthdayPreferences } from './BirthdayPreferences/BirthdayPreferences'
import RegistryInfo from './RegistryInfo/RegistryInfo'
import { CurrentUser } from '../../global'

export interface NavigationSettings {
  path: string
  route: string
  active: (pathname: string) => boolean
  label: string
  component: React.ComponentType
  isVisible: (currentUser?: CurrentUser) => boolean
}

export const AccountInfoSection = {
  active: (pathname: string) =>
    pathname === settingsPath || pathname === settingsAccountInfoPath,
  path: settingsAccountInfoPath,
  route: settingsAccountInfoPath,
  label: 'Account Info',
  isVisible: () => true,
  component: AccountInfo,
}

export const RegistryInfoSection = {
  active: (pathname: string) => pathname === settingsRegistryPath,
  path: settingsRegistryPath,
  route: settingsRegistryPath,
  label: 'Registry Info',
  isVisible: () => true,
  component: RegistryInfo,
}

export const BirthdayPreferencesSection = {
  active: (pathname: string) => pathname === settingsBirthdayPreferencesPath,
  path: settingsBirthdayPreferencesPath,
  route: settingsBirthdayPreferencesPath,
  label: 'Preferences',
  isVisible: (currentUser?: CurrentUser) =>
    currentUser?.currentRegistry?.type === 'birthday' ||
    currentUser?.currentRegistry?.type === 'holiday',
  component: BirthdayPreferences,
}

export const RegistryCollaboratorsSection = {
  active: (pathname: string) => pathname === settingsRegistryCollaboratorsPath,
  path: settingsRegistryCollaboratorsPath,
  route: settingsRegistryCollaboratorsPath,
  label: 'Registry Collaborators',
  isVisible: (currentUser?: CurrentUser) =>
    currentUser?.currentRegistry?.currentUserRole === REGISTRY_ROLES.OWNER,
  component: RegistryCollaborators,
}

export const ShippingAddressSection = {
  active: (pathname: string) => pathname === settingsShippingAddressPath,
  path: settingsShippingAddressPath,
  route: settingsShippingAddressPath,
  label: 'Shipping Address',
  isVisible: () => true,
  component: ShippingAddress,
}

export const CashFundPreferencesSection = {
  active: (pathname: string) => pathname === settingsCashFundPreferencesPath,
  path: settingsCashFundPreferencesPath,
  route: settingsCashFundPreferencesPath,
  label: 'Cash Fund Preferences',
  isVisible: () => true,
  component: CashFundPreferences,
}

export const RegistryVisibilitySection = {
  active: (pathname: string) => pathname === settingsRegistryVisibilityPath,
  path: settingsRegistryVisibilityPath,
  route: settingsRegistryVisibilityPath,
  label: 'Visibility & Privacy',
  isVisible: () => true,
  component: RegistryVisibility,
}

export const EmailPreferencesSection = {
  active: (pathname: string) => pathname === settingsEmailPreferencesPath,
  path: settingsEmailPreferencesPath,
  route: settingsEmailPreferencesPath,
  label: 'Communication Preferences',
  isVisible: () => true,
  component: EmailPreferences,
}

export const GiftCardsAndPromotionsSection = {
  active: (pathname: string) => pathname === settingsGiftCardsAndPromotionsPath,
  path: settingsGiftCardsAndPromotionsPath,
  route: settingsGiftCardsAndPromotionsPath,
  label: 'Gift Cards, Promos & Gift Funds',
  isVisible: () => true,
  component: GiftCardsAndPromotions,
}

export const YourOrdersSection = {
  active: (pathname: string) => pathname === settingsYourOrdersPath,
  path: settingsYourOrdersPath,
  route: settingsYourOrdersPath,
  label: 'Your Orders',
  isVisible: () => true,
  component: YourOrders,
}

export const ConsolidatedShippingSection = {
  active: (pathname: string) => pathname === settingsConsolidatedShippingPath,
  path: settingsConsolidatedShippingPath,
  route: settingsConsolidatedShippingPath,
  label: 'Shipping Preferences',
  isVisible: () => true,
  component: ConsolidatedShipping,
}
